import React from 'react';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import MenuItem from '../ui-components/MenuItem';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import {
    prepareAttachment,
    removeFailedMessageAction,
    sendChatMessage,
} from 'flow/actions/chat-actions';
import useAppContext from 'flow/hooks/useAppContext';
import { Message, NewAttachment } from 'flow/types/Chats';

import { trimEnd } from 'lodash';
import ContextMenu from 'flow/components/ContextMenu';
import Tooltip from 'flow/components/ui-components/Tooltip';
import Icon from '../../components/ui-components/Icon';

interface Props {
    chatSessionKey: ChatSessionKey;
    message: TypedMap<Message>;
}

const FailedMessageContextMenu = ({ chatSessionKey, message }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const clientKey = useAppSelector((state) =>
        state.chats.getIn(['client', 'key']),
    );
    const handleRemoveMessage = () => {
        dispatch(removeFailedMessageAction(chatSessionKey, message.get('key')));
    };

    const resendMessage = () => {
        handleRemoveMessage();
        const attachment = message.get('attachment') as TypedMap<NewAttachment>;

        dispatch(
            attachment?.get('file')
                ? prepareAttachment(
                      chatSessionKey,
                      clientKey,
                      trimEnd(message.get('message')),
                      message.get('stylings'),
                      attachment?.toJS(),
                  )
                : sendChatMessage(
                      chatSessionKey,
                      clientKey,
                      trimEnd(message.get('message')),
                      message.get('stylings'),
                      attachment,
                      message.get('alsoAsSMS'),
                  ),
        );
    };

    return (
        <Tooltip label={i18next.t('chat.attachment.tooltip.failed_to_send')}>
            <ContextMenu
                triggerLabel={i18next.t(
                    'chat.attachment.tooltip.failed_to_send',
                )}
                icon={<Icon iconKey="error" />}
                placement="bottom-end"
                className="text-red bg-transparent"
            >
                <MenuItem onClick={handleRemoveMessage}>
                    {i18next.t('remove')}
                </MenuItem>
                <MenuItem onClick={resendMessage}>
                    {i18next.t('chat.try_again')}
                </MenuItem>
            </ContextMenu>
        </Tooltip>
    );
};

export default FailedMessageContextMenu;
